import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Pipe({
    name: 'translateCulturePipe',
})
export class translateCulturePipe implements PipeTransform {

    constructor(private translate: TranslateService) { }

    transform(value: string) {
        if (value && value.length > 0) {
            var arr = value.split(", ");
            var convert = [];
            if (arr.length > 0) {
                arr.forEach(element => {
                    convert.push(this.translate.instant(element));
                });
                value = convert.join(", ");
            }
            else {
                value = this.translate.instant(value);
            }
        }

        return value;
    }
}


// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/pipes/translate-culture-pipe.ts